import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import PromotionTooltip from './PromotionTooltip';
import Tooltip from '../../../../../components/Tooltip';
import Button from '../../../../../components/Buttons/Button';

const TableActionsRow = ({ report, showPromotionTooltip, onReportAlert, onReportTimer }) => {
  const handleMarketDownload = (e) => {
    e.preventDefault();
    window.location.replace(window.location.origin + report.download_link);
  };

  const handleReportAlert = (e) => {
    e.preventDefault();
    if (report.frequency === 'One Time') return;
    onReportAlert(report);
  };

  const handleReportTimer = () => {
    onReportTimer(report);
  };

  const alertButton = (
    <Tooltip placement="topRight" content="Set Alert">
      <Button size="sm" shape="square" variant="secondary" onClick={handleReportAlert}>
        <i
          className={cx('hicon-alert-bell text-16', {
            'hicon-alert-bell-on text-blue':
              report['subscribed?'] && report.frequency !== 'One Time',
            'text-muted': report.frequency === 'One Time',
          })}
        />
      </Button>
    </Tooltip>
  );

  return (
    <div className="text-nowrap custom-reports-actions text-xs d-flex justify-content-around">
      {showPromotionTooltip ? <PromotionTooltip>{alertButton}</PromotionTooltip> : alertButton}
      <Tooltip placement="topRight" content="Download">
        <Button size="sm" shape="square" variant="secondary" onClick={handleMarketDownload}>
          <i className="hicon-download-thin text-16" />
        </Button>
      </Tooltip>

      <Tooltip placement="topRight" content="History">
        <Button size="sm" shape="square" variant="secondary" onClick={handleReportTimer}>
          <i className="hicon-history-dashed text-16" />
        </Button>
      </Tooltip>
    </div>
  );
};

TableActionsRow.propTypes = {
  report: T.object.isRequired,
  showPromotionTooltip: T.bool.isRequired,
  onReportAlert: T.func.isRequired,
  onReportTimer: T.func.isRequired,
};

export default TableActionsRow;
